import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import compose from 'ramda/es/compose';
import { Banner } from './banner.component';
import { AccessoryActions } from '../../reducers/accessories/accessories.redux';
import { selectBannerContent } from '../../reducers/accessories/accessories.selectors';

const mapStateToProps = createStructuredSelector({
  contentEntry: selectBannerContent,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  closeBanner: AccessoryActions.closeBanner,
}, dispatch);

export default compose(connect(mapStateToProps, mapDispatchToProps))(Banner);
